
const config = {
     API_KEY:  "pub_26439a18a7afee357745ad5d6767011e3d091"
}
export default config;